export default __webpack_public_path__ + "static/media/123-regenrinnenfrei.140d7232.png";